var path = 'src/app/forms/fields/textarea-field.html';
var html = "<div class=pid-warning>Please, do not put patient identifiable information in this field.</div> <textarea frm-model frm-required ng-required=required() ng-model=model class=form-control rows=\"{{ rows || 5 }}\"></textarea> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/forms/fields/textarea-field.html
 ** module id = 304
 ** module chunks = 0
 **/